var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35969 11.769C6.54469 11.923 6.77169 12 6.99969 12C7.22769 12 7.45469 11.923 7.63969 11.769L12.4397 7.769C12.8637 7.415 12.9207 6.785 12.5677 6.36C12.2147 5.936 11.5837 5.88 11.1597 6.232L7.99969 8.865V1C7.99969 0.448 7.55169 0 6.99969 0C6.44769 0 5.99969 0.448 5.99969 1V8.865L2.83969 6.231C2.41569 5.879 1.78569 5.936 1.43169 6.359C1.07869 6.784 1.13569 7.415 1.55969 7.769L6.35969 11.769Z",
    fill: "#BABDCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H1C0.448 13 0 13.447 0 14C0 14.553 0.448 15 1 15H13C13.553 15 14 14.553 14 14C14 13.447 13.553 13 13 13Z",
    fill: "#BABDCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.01f710b451893773f76d3c5f3db54ac9.svg";
export { ForwardRef as ReactComponent };